// @flow

export const REFRESH_TOKEN = 'REFRESH_TOKEN'
export const ACCESS_TOKEN = 'ACCESS_TOKEN'
